// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"8bfa0bda","288":"8bfa0bda"}[chunkId] + ".chunk.css";
};